module.exports = __webpack_public_path__ + "img/pethouse16.9464ed5d.jpg";